export class Template {
  constructor(name) {
    const args = [
      `\n%c${name}%cby @andrevenancio%cexclusive for hicetnunc.xyz\n`,
      "background: #000000; color: #00ffff; font-size: x-small;padding: 4px;",
      "background: #00ffff; color: #000000; font-size: x-small;padding: 4px;",
      "background: transparent; color: #999999; font-size: x-small;padding: 4px;",
    ]

    console.log(...args)

    this.width = window.innerWidth
    this.height = window.innerHeight
    this.ratio = Math.min(2, window.devicePixelRatio)

    this.mouse = { x: 0, y: 0, nx: 0, ny: 0, down: false }

    // mouse
    if ("ontouchstart" in global.window) {
      global.addEventListener("touchstart", this._down.bind(this), {
        passive: false,
      })
      global.addEventListener("touchmove", this._move.bind(this), {
        passive: false,
      })
      global.addEventListener("touchend", this._up.bind(this), {
        passive: false,
      })
    } else {
      global.addEventListener("mousedown", this._down.bind(this))
      global.addEventListener("mousemove", this._move.bind(this))
      global.addEventListener("mouseup", this._up.bind(this))
    }

    window.addEventListener("resize", () => this._resize(), false)

    this.setup()
    this._resize()
    this._update()
  }

  // ---------------
  // PRIVATE
  // ---------------
  _down(e) {
    this.mouse.down = true
    const event = e.changedTouches ? e.changedTouches[0] : e

    const x = event.clientX * this.ratio
    const y = event.clientY * this.ratio

    // real mouse position
    this.mouse.x = x
    this.mouse.y = y

    // normalised mouse position
    this.mouse.nx = x / this.width
    this.mouse.ny = y / this.height

    // update down with down coordinates
    // (note: this.mouse will be accessible and updated every frame)
    this.down(x, y)
  }

  _move(e) {
    const event = e.changedTouches ? e.changedTouches[0] : e

    const x = event.clientX * this.ratio
    const y = event.clientY * this.ratio

    // real mouse position
    this.mouse.x = x
    this.mouse.y = y

    // normalised mouse position
    this.mouse.nx = x / this.width
    this.mouse.ny = y / this.height

    this.move(x, y)
  }

  _up(e) {
    this.mouse.down = false
    const event = e.changedTouches ? e.changedTouches[0] : e

    const x = event.clientX * this.ratio
    const y = event.clientY * this.ratio

    // real mouse position
    this.mouse.x = x
    this.mouse.y = y

    // normalised mouse position
    this.mouse.nx = x / this.width
    this.mouse.ny = y / this.height

    this.up(x, y)
  }

  _resize() {
    this.width = window.innerWidth
    this.height = window.innerHeight

    this.resize(this.width, this.height, this.ratio)
  }

  _update(timestamp) {
    this.update(timestamp / 1000)
    requestAnimationFrame(this._update.bind(this))
  }

  // ---------------
  // PUBLIC
  // ---------------
  setup() {}

  resize() {}

  down() {}

  move() {}

  up() {}

  update() {}
}
